import { Card, Collapse, Col, Row, Button, Form, Checkbox, Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SingleEvent from '../../../common/SingleEvent';
import { errorCatch, GET } from 'fennec-ui';
import { Action } from 'fennec-ui'
import YImage from '../../../common/YImage';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
import LevelBreadcrumbs from '../../components/LevelBreadcrumbs';
import EventsByIDBlock from '../../components/EventsByIDBlock';
import PageLayout from '../../components/PageLayout';

const { Panel } = Collapse;

export default function CommonEventsAdminByID(props) {

    let { id } = useParams();
    const { auth } = props;
    const sourceKey = "admin";
    
    return (
        <PageLayout hideSider={true}>
            <EventsByIDBlock auth={auth} id={id} sourceKey={sourceKey}/>    
        </PageLayout>
    );
}
